import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="container" style={{ padding: "80px var(--page-pad)" }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        style={{ maxWidth: "640px", margin: "0 auto" }}
      >
        {/* Large 404 Number */}
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          style={{ textAlign: "center", marginBottom: "48px" }}
        >
          <h1
            style={{
              fontSize: "clamp(100px, 15vw, 180px)",
              fontWeight: 800,
              lineHeight: 1,
              margin: 0,
              color: "var(--nba-green)",
              letterSpacing: "-0.04em",
            }}
          >
            404
          </h1>
        </motion.div>

        {/* Main Content Card */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="about-card"
          style={{ textAlign: "center", padding: "48px 40px" }}
        >
          <h2
            style={{
              fontSize: "32px",
              fontWeight: 700,
              margin: "0 0 16px 0",
              color: "var(--text)",
            }}
          >
            Page Not Found
          </h2>

          <p
            style={{
              fontSize: "16px",
              color: "var(--muted)",
              margin: "0 0 40px 0",
              lineHeight: 1.6,
            }}
          >
            Oops! The page you're looking for seems to have wandered off. It might have been moved, deleted, or perhaps it never existed in the first place.
          </p>

          {/* Action Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.5 }}
            style={{
              display: "flex",
              gap: "16px",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.98 }}>
              <Link
                to="/"
                className="button button--primary"
                style={{
                  height: "40px",
                  padding: "0 24px",
                  fontSize: "14px",
                  fontWeight: 600,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  textDecoration: "none",
                }}
              >
                <Home size={18} aria-hidden="true" />
                Go to Homepage
              </Link>
            </motion.div>

            <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.98 }}>
              <button
                onClick={() => window.history.back()}
                style={{
                  height: "40px",
                  padding: "0 24px",
                  fontSize: "14px",
                  fontWeight: 600,
                  borderRadius: "10px",
                  border: "1px solid var(--nba-green)",
                  background: "#fff",
                  color: "var(--nba-green)",
                  cursor: "pointer",
                  transition: "all 180ms ease",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  fontFamily: "inherit",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(0, 71, 0, 0.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#fff";
                }}
              >
                <ArrowLeft size={18} aria-hidden="true" />
                Go Back
              </button>
            </motion.div>
          </motion.div>
        </motion.div>

        {/* Footer Text */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          style={{ marginTop: "32px", textAlign: "center" }}
        >
          <p style={{ fontSize: "14px", color: "var(--muted)", margin: 0 }}>
            If you believe this is an error, please{" "}
            <Link
              to="/contact"
              style={{
                color: "var(--nba-green)",
                fontWeight: 600,
                textDecoration: "none",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = "underline";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = "none";
              }}
            >
              contact us
            </Link>
            .
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
}
